<template>
    <div class="config-bar" :class="{disabled: request_status == 'loading'}">
        <div>
            <strong class="config-bar-header inline" justify="between">
                <span>Конфиг</span>
                <img title="Сбросить" @click="reset()" v-show="showResetButton" src="~@/assets/img/close.svg">
            </strong>
            <div v-if="get_request_status != 'loading'">
                <div class="config-list" v-if="Object.keys(config.list).length">
                    <div class="config-item" @click="selectConfig(key)" :class="{_active: config.active == key}" v-for="(item, key) in config.list" :key="key"><div>{{ item.name }}</div></div>
                </div>
                <p v-else class="config-notice">Укажите имя вашего первого конфига внизу</p>
            </div>
            <p v-else class="config-notice">Загрузка...</p>
        </div>

        <div class="config-controls">
            <div class="config-update" v-if="config.active != '-1' || showUpdateButton">
                <div class="button _accept" v-show="config.active != '-1'" @click="showShare()">Поделиться</div>
                <div class="button _second" v-show="showUpdateButton" @click="update()">Обновить</div>
                <div class="button _decline" v-show="config.active != '-1'" @click="remove()">Удалить</div>
            </div>
            <div class="config-new">
                <input :class="{_error: nameIsTaken}" class="_mini" type="text" v-model="config_name" placeholder="Название"/>
                <div :class="{disabled: config_name == '' || nameIsTaken}" class="button _second" @click="save()">Сохранить</div>
            </div>
        </div>
        <div class="blackout" v-if="share.show" @click="hideShare()">
            <div class="popup" @click.stop :loading="share.status">
                <h1>Передать конфиг "{{ config.list[config.active].name }}"</h1>
                <div class="form-item">
                    <select v-model="share.select">
                        <option value="-1">Выбрать пользователя</option>
                        <option v-for="(item, key) in share.list" :key="key" :value="item.id" v-show="item.email != $store.state.auth.user.username">{{ item.email }}</option>
                    </select>
                </div>
                <div class="inline">
                    <div class="button _free _accept" :class="{disabled: share.select == -1}" @click="shareConfig()">Передать</div>
                    <div class="button _free _decline" @click="hideShare()">Отмена</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import data from '@/mixins/data'
    export default {
        mixins: [data],
        data () {
            return {
                config_name: '',
                config: {
                    active: -1, // текущий конфиг
                    list: {} // список всех конфигов для текущей страницы
                },
                backupDefault: {
                    settings: '{}',
                    filters: '{}'
                },
                request_status: '',
                get_request_status: '',
                share: {
                    show: false,
                    select: -1,
                    list: [],
                    status: ''
                }
            }
        },
        computed: {
            nameIsTaken () {
                if (this.config_name == '') return false
                let busy = false
                for (let prop in this.config.list) {
                    if (this.config.list[prop].name == this.config_name) busy = true
                }
                return busy
            },
            showResetButton () {
                if (this.get_request_status == 'loading') return false

                if (this.backupDefault.settings != JSON.stringify(this.$store.state.settings[this.$route.name]) ||
                    this.backupDefault.filters != JSON.stringify(this.$store.state.filters[this.$route.name])) {
                    return true
                }
                return false
            },
            showUpdateButton () {
                if (this.config.active == -1) return false

                let filters = JSON.stringify(this.$store.state.filters[this.$route.name])
                let settings = JSON.stringify(this.$store.state.settings[this.$route.name])
                let config_filters = JSON.stringify(this.config.list[this.config.active].filters)
                let config_settings = JSON.stringify(this.config.list[this.config.active].settings)

                if (filters != config_filters || settings != config_settings) {
                    return true
                }
                return false
            }
        },
        methods: {
            shareConfig () {
                return new Promise((resolve, reject) => {
                    this.axios.post('api/admin/v2/config/' + this.config.active + '/share/' + this.share.select)
                        .then(() => {

                            let msg = {
                                message: 'Конфиг передан успешно',
                                status: 'success'
                            }
                            this.$store.dispatch('utils/showMessage', msg)

                            this.share = {
                                status: '',
                                select: -1,
                                list: [],
                                show:false
                            }

                            resolve()
                        })
                        .catch(() => {
                            this.share.status = ''
                            let msg = {
                                message: 'Ошибка при передаче конфига',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            getAdmins () {
                return new Promise((resolve) => {
                    this.share.status = 'loading'
                    this.axios.get('api/admin/v2/user/search?role=admin')
                        .then((resp) => {
                            if (resp.data.response) {
                                this.share.list = resp.data.response
                            }
                            this.share.status = ''
                            resolve()
                        })
                })
            },
            showShare () {
                this.share.show = true

                this.getAdmins();
            },
            hideShare () {
                this.share.show = false
            },
            reset () {
                this.config.active = -1
                this.$store.commit('filters/update_all', {
                    page: this.$route.name,
                    filters: JSON.parse(this.backupDefault.filters)
                })
                this.$store.commit('settings/update_all', {
                    page: this.$route.name,
                    settings: JSON.parse(this.backupDefault.settings)
                })
            },
            update () {
                this.request_status = 'loading'
                return new Promise((resolve, reject) => {
                    this.axios.post('api/admin/v2/config/' + this.config.active, {
                        settings: JSON.stringify(this.$store.state.settings[this.$route.name]),
                        filters: JSON.stringify(this.$store.state.filters[this.$route.name])
                    })
                        .then((resp) => {
                            this.request_status = ''
                            let msg = {
                                message: 'Конфиг обновлен',
                                status: 'success'
                            }
                            this.$store.dispatch('utils/showMessage', msg)

                            this.writeConfig(resp.data.response.list)
                            this.selectConfig(this.config.active)

                            resolve()
                        })
                        .catch(() => {
                            this.request_status = ''
                            let msg = {
                                message: 'Ошибка при обновлении конфига',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            save () {
                /*this.savedConfig.list[name] = {
                    filters: JSON.parse(JSON.stringify(this.$store.state.filters[this.$route.name])),
                    settings: JSON.parse(JSON.stringify(this.$store.state.settings[this.$route.name]))
                }

                this.updateStore()

                this.savedConfig.active = this.config_name

                this.config_name = ''
                this.updateShowCounter++*/
                this.request_status = 'loading'
                return new Promise((resolve, reject) => {
                    this.axios.post('api/admin/v2/config', {
                        name: this.config_name,
                        settings: JSON.stringify(this.$store.state.settings[this.$route.name]),
                        filters: JSON.stringify(this.$store.state.filters[this.$route.name]),
                        type: this.$route.name
                    })
                    .then((resp) => {
                        this.request_status = ''
                        let msg = {
                            message: 'Конфиг сохранен',
                            status: 'success'
                        }
                        this.$store.dispatch('utils/showMessage', msg)

                        this.writeConfig(resp.data.response.list)
                        this.config_name = ''
                        this.selectConfig(resp.data.response.id)
                        resolve()
                    })
                    .catch(() => {
                        this.request_status = ''
                        let msg = {
                            message: 'Ошибка при сохранении конфига',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
            remove () {
                this.request_status = 'loading'
                return new Promise((resolve, reject) => {
                    this.axios.delete('api/admin/v2/config/' + this.config.active)
                        .then(() => {
                            this.request_status = ''
                            let msg = {
                                message: 'Конфиг удалён',
                                status: 'success'
                            }
                            this.$store.dispatch('utils/showMessage', msg)

                            delete this.config.list[this.config.active]
                            this.config.active = -1

                            resolve()
                        })
                        .catch(() => {
                            this.request_status = ''
                            let msg = {
                                message: 'Ошибка при удалении конфига',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },

            selectConfig (id) {
                this.reset()
                this.config.active = id
                this.applyConfig(id)
            },
            correctConfig () { // корректировка конкретного конфига
                let configFilters = this.config.list[this.config.active].filters
                for (let colKey in configFilters) { // перебираем сохраненные фильтры
                    if (!Object.prototype.hasOwnProperty.call(this.$store.state.filters[this.$route.name], colKey)) { // если в актуальном фильтре уже нет такой колонки
                        // console.log('>>> remove filter column: ' + colKey)
                        delete configFilters[colKey] // ее надо убрать из сохраненного фильтра
                    } else {
                        let selectAll = true
                        for (let fieldKey in configFilters[colKey]) {
                            if (fieldKey != 'all') {
                                if (!Object.prototype.hasOwnProperty.call(this.$store.state.filters[this.$route.name][colKey], fieldKey)) { // если в актуальном фильтре уже нет такого поля
                                    // console.log('>>> remove filter field: ' + fieldKey + ' (column: ' + colKey + ')')
                                    delete configFilters[colKey][fieldKey]
                                } else {
                                    if (!configFilters[colKey][fieldKey] && selectAll) { // если опция была выключена
                                        selectAll = false
                                    }
                                }
                            }
                        }
                        configFilters[colKey]['all'] = selectAll
                    }
                }

                let configSettings = this.config.list[this.config.active].settings
                let selectAll = true
                for (let fieldKey in configSettings) {
                    if (fieldKey != 'all') {
                        if (!Object.prototype.hasOwnProperty.call(this.$store.state.settings[this.$route.name], fieldKey)) {
                            // console.log('>>> remove settings field: ' + fieldKey)
                            delete configSettings[fieldKey]
                        } else {
                            if (!configSettings[fieldKey].value && selectAll) { // если опция была выключена
                                selectAll = false
                            }
                        }
                    }
                }
                configSettings['all'].value = selectAll
            },
            applyConfig (id) {
                this.correctConfig()
                this.$store.commit('filters/update_all', {
                    page: this.$route.name,
                    filters: JSON.parse(JSON.stringify(this.config.list[id].filters))
                })
                this.$store.commit('settings/update_all', {
                    page: this.$route.name,
                    settings: JSON.parse(JSON.stringify(this.config.list[id].settings))
                })
            },
            backupDefaultState () {
                this.backupDefault.settings = JSON.stringify(this.$store.state.settings[this.$route.name])
                this.backupDefault.filters = JSON.stringify(this.$store.state.filters[this.$route.name])
            },
            getConfig () {
                this.get_request_status = 'loading'
                return new Promise((resolve, reject) => {
                    this.axios.get('api/admin/v2/config?type=' + this.$route.name)
                        .then((resp) => {
                            this.get_request_status = ''

                            this.writeConfig(resp.data.response.list)
                            this.backupDefaultState()

                            this.loadStoredConfig()

                            resolve()
                        })
                        .catch(() => {
                            this.get_request_status = ''
                            let msg = {
                                message: 'Ошибка при получении конфига',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            writeConfig (list) {
                for (let prop in list) {
                    this.config.list[prop] = {}
                    this.config.list[prop].name = list[prop].name
                    this.config.list[prop].settings = JSON.parse(list[prop].settings)
                    this.config.list[prop].filters = JSON.parse(list[prop].filters)
                }
            },
            loadStoredConfig () {

                let key = 'config_' + this.$route.name
                if (localStorage[key]) {
                    let config = JSON.parse(localStorage[key])

                    this.$store.commit('filters/update_all', {
                        page: this.$route.name,
                        filters: config.filters
                    })
                    this.$store.commit('settings/update_all', {
                        page: this.$route.name,
                        settings: config.settings
                    })

                    localStorage.removeItem(key);
                }
                // console.log(JSON.parse(localStorage['app']))
            }
        },
        created () {
            this.getConfig()
        }
    }
</script>